import moment, { Moment } from 'moment-timezone';
import { SavedMentionSearchApiModel } from '../../../api/mentions/model/saved-mention-search.api.model';
import { isEqual } from 'underscore';

export class AutoSavingConfigModel {
    enabled: boolean;
    lastSaveDate: Date;
    folderIds: number[];
    tagIds: number[];
    startDate: Moment;
    endDate: Moment;
    timezone: string;

    constructor(searchApiModel?: SavedMentionSearchApiModel) {
        if (searchApiModel) {
            this.enabled = searchApiModel.savingEnabled;
            this.lastSaveDate = searchApiModel.lastSaved ? new Date(searchApiModel.lastSaved) : null;
            this.folderIds = searchApiModel.savingFolders;
            this.tagIds = searchApiModel.savingTags;
            this.startDate = searchApiModel.savingStart ? moment(searchApiModel.savingStart) : null;
            this.endDate = searchApiModel.savingEnd ? moment(searchApiModel.savingEnd) : null;
            this.timezone = searchApiModel.timezone;
        }
    }

    public equals(other: AutoSavingConfigModel): boolean {
        if (!other) {
            return false;
        }

        if (this.enabled !== other.enabled) {
            return false;
        } else if (this.enabled === false && other.enabled === false) {
            // if both Auto-Saving options are disabled, do not check the remaining settings
            return true;
        }

        if (!isEqual(this.folderIds, other.folderIds)) {
            return false;
        }

        if (!isEqual(this.tagIds, other.tagIds)) {
            return false;
        }

        if (this.startDate) {
            if (this.startDate.isValid() && other.startDate && other.startDate.isValid()) {
                if (this.startDate.diff(other.startDate) !== 0) {
                    return false;
                }
            } else if (this.startDate.isValid() || other.startDate?.isValid()) {
                return false;
            }
        }

        if (this.endDate) {
            if (this.endDate.isValid() && other.endDate && other.endDate.isValid()) {
                if (this.endDate.diff(other.endDate) !== 0) {
                    return false;
                }
            } else if (this.endDate.isValid() || other.endDate?.isValid()) {
                return false;
            }
        }

        if (this.timezone !== other.timezone) {
            return false;
        }
        return true;
    }
}
